import type { SVGProps } from 'react';
import { palette } from '../tokens.ts';

/** A tapered engraved rule with a central lozenge, used between sections. */
export function Vignette({ color = palette.gold, ...rest }: SVGProps<SVGSVGElement> & { color?: string }) {
  return (
    <svg viewBox="0 0 240 16" width="240" height="16" aria-hidden="true" focusable="false" {...rest}>
      <g fill={color} stroke="none">
        <path d="M4 8 L104 7 L108 8 L104 9 Z" />
        <path d="M236 8 L136 7 L132 8 L136 9 Z" />
        <path d="M120 1 L128 8 L120 15 L112 8 Z" />
        <circle cx={108} cy={8} r={1.6} />
        <circle cx={132} cy={8} r={1.6} />
        <circle cx={96} cy={4} r={0.9} />
        <circle cx={96} cy={12} r={0.9} />
        <circle cx={144} cy={4} r={0.9} />
        <circle cx={144} cy={12} r={0.9} />
      </g>
      <path d="M120 4 L124 8 L120 12 L116 8 Z" fill={palette.paper} />
    </svg>
  );
}

/** Scroll-work flourish for the corners of a cartouche. Rotate for other corners. */
export function CornerFlourish({
  color = palette.ink,
  ...rest
}: SVGProps<SVGSVGElement> & { color?: string }) {
  return (
    <svg viewBox="0 0 48 48" width="48" height="48" aria-hidden="true" focusable="false" {...rest}>
      <g fill="none" stroke={color} strokeLinecap="round">
        <path d="M2 46 V14 C2 7 7 2 14 2 H46" strokeWidth={1.2} />
        <path d="M7 46 V18 C7 12 12 7 18 7 H46" strokeWidth={0.6} />
        <path d="M14 14 C20 8 28 12 24 18 C21 22 15 19 18 15" strokeWidth={1} />
        <path d="M24 18 C30 22 34 16 40 18" strokeWidth={0.7} />
        <path d="M18 24 C22 30 16 34 18 40" strokeWidth={0.7} />
      </g>
      <circle cx={14} cy={14} r={1.8} fill={color} />
    </svg>
  );
}
